import {Pipe, PipeTransform} from '@angular/core';
import {StatesHelper} from '../../states/states.helper';
import Product from '../../_entities/products/product.entity';

@Pipe({
    name: 'productImageUrl',
    pure: true
})
export class ProductImageUrlPipe implements PipeTransform {
    transform(productId: number): string {
        const product = StatesHelper.productsEntitiesState.entities[productId];
        if (!product) return;
        return new Product(product).displayImageUrl;
    }
}
